export const SIDEBAR_ROUTE_MAP: Record<string, string> = {
	faqs: "faq",
	faq: "faq",
	contact: "contact-us",
	"contact-us": "contact-us",
	requests: "lawsuits",
	"account-requests": "account-requests",
	referral: "referral",
	reports: "reports",
	complaint: "complaints",
	complaints: "complaints",
	notices: "notices",
	notes: "notices",
	lawsuits: "lawsuits",
	"professional-monitoring": "professional-monitoring",
	"reports-complaints": "reports/reports-complaints",
	"reports-notices": "reports/reports-notices",
	"reports-professional-monitoring": "reports/reports-professional-monitoring",
	"reports-comprehensive": "reports/reports-comprehensive",
	"reports-users": "reports/users",
	"reports-beneficiaries": "reports/beneficiaries",
	"reports-statistics": "reports/statics",
	"reports-requests-status": "reports/reports-requests-status",
	"reports-sms-logs": "reports/reports-sms-logs",
	"reports-saved-requests": "reports/reports-saved-requests",
	"reports-referred-to-department": "reports/reports-referred-to-department",
	"reports-under-review": "reports/reports-under-review",
	"reports-referred-to-police": "reports/reports-referred-to-police",
	"reports-awaiting-statement": "reports/reports-awaiting-statement",
	"reports-awaiting-requirements": "reports/reports-awaiting-requirements",
	dashboard: "dashboard",
	profile: "profile",
	notifications: "notifications",
	users: "users",
	"users/roles": "roles",
	roles: "roles",
	"transaction-lifespan": "transaction-lifespan",
	"holidays-management": "holidays-management",
	"delegation-management": "delegation-management",
	"delegated-requests": "delegated-requests",
	"glad-referrals": "glad-referrals",
	"audit-log": "audit-log",
	"audit-log/transactions": "audit-log/transactions",
	"audit-log/general": "audit-log/general",
	"audit-log-transactions": "audit-log/transactions",
	"audit-log-general": "audit-log/general",
	feedback: "feedback",
	"conversation-history": "conversation-history",
} as const;

export function resolveSidebarRoute(routerLinkName: string | undefined): string | undefined {
	if (routerLinkName == null || routerLinkName.trim() === "") return undefined;
	const mapped = SIDEBAR_ROUTE_MAP[routerLinkName];
	return mapped ?? routerLinkName;
}
